import { render } from "./index.vue?vue&type=template&id=72eb18dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=72eb18dc&scoped=true&lang=css"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72eb18dc"]])

export default __exports__